import { createSlice } from "@reduxjs/toolkit";
import * as actions from "./sliceActions";
import { act } from "react";

const initialState = {
  loading: false,
  user: JSON.parse(localStorage.getItem("user")) || {},
  tempUser: JSON.parse(localStorage.getItem("tempUser")) || {},
  rememberMe: JSON.parse(localStorage.getItem("user"))?.rememberMe || false,
  profile: {},
  caretakerProfile: {},
  properties: [],
  houses: [],
  property: {},
  tenants: [],
  expenses: [],
  invoices: [],
  waterinvoices: [],
  rentInvoices: [],
  allLandlordInvoices: [],
  housesreport: [],
  statistics: [],
  pendingpayments: [],
  payments: [],
  tenantsdata: [],
  tenantsinvoices: [],
  tenantpayments: [],
  paidinvoices: [],
  unpaidinvoices: [],
  error: "",
  message: "",
};

const landlordSlice = createSlice({
  name: "landlord",
  initialState,
  reducers: {
    clearTenants: (state) => {
      state.tenants = [];
    },
    //clear profile
    clearProfile: (state) => {
      console.log("clearing profile");
      state.profile = {};
    },
    clearProperty: (state) => {
      state.property = {};
    },
    clearProperties: (state) => {
      console.log("properties before", state.properties);
      state.properties = [];
      console.log("properties cleared", state.properties);
    },
    clearHouses: (state) => {
      state.houses = {};
    },
    clearWaterInvoices: (state) => {
      state.waterinvoices = "";
    },
    clearRentInvoices: (state) => {
      state.invoices = "";
    },
    clearHouseReports: (state) => {
      state.housesreport = "";
    },
    clearPayments: (state) => {
      console.log("payments before", state.payments);
      state.payments = "";
    },
    clearInvoicesPaid: (state) => {
      state.paidinvoices = "";
    },
    clearUnpaidInvoices: (state) => {
      state.unpaidinvoices = "";
    },
    setRememberMe: (state, action) => {
      state.rememberMe = action.payload;
      // Update localStorage user data with new rememberMe value
      const currentUser = JSON.parse(localStorage.getItem("user")) || {};
      const updatedUser = { ...currentUser, rememberMe: action.payload };
      localStorage.setItem("user", JSON.stringify(updatedUser));
    },
    clearRememberMe: (state) => {
      state.rememberMe = false;
      // Update localStorage user data
      const currentUser = JSON.parse(localStorage.getItem("user")) || {};
      const updatedUser = { ...currentUser, rememberMe: false };
      localStorage.setItem("user", JSON.stringify(updatedUser));
    },
  },
  extraReducers: (builder) => {
    builder.addCase(actions.verifyUser.pending, (state) => {
      state.loading = true;
    });

    builder.addCase(actions.verifyUser.fulfilled, (state, action) => {
      state.loading = false;
      state.message = "verify success";
      state.error = "";
    });
    builder.addCase(actions.verifyUser.rejected, (state, action) => {
      state.loading = false;
      state.error =
        action.error.message.split(" ")[
          action.error.message.split(" ").length - 1
        ];
      state.message = action.error.message;
    });

    builder.addCase(actions.loginUser.pending, (state) => {
      state.loading = true;
    });

    builder.addCase(actions.loginUser.fulfilled, (state, action) => {
      state.loading = false;
      state.user = action.payload;
      state.rememberMe = action.meta.arg.rememberMe || false;
      // Store user data with rememberMe flag in localStorage
      const userDataWithRememberMe = {
        ...action.payload,
        rememberMe: action.meta.arg.rememberMe || false,
      };
      localStorage.setItem("user", JSON.stringify(userDataWithRememberMe));
      state.message = "login successful";
      state.error = "";
    });
    builder.addCase(actions.loginUser.rejected, (state, action) => {
      state.loading = false;
      state.error =
        action.error.message.split(" ")[
          action.error.message.split(" ").length - 1
        ];
      state.message = action.error.message;
    });

    builder.addCase(actions.getProfile.pending, (state) => {
      state.loading = true;
    });

    builder.addCase(actions.getProfile.fulfilled, (state, action) => {
      state.loading = false;
      state.profile = action.payload.data;
      state.message = "fetched profile successfully";
      state.error = "";
    });
    builder.addCase(actions.getProfile.rejected, (state, action) => {
      state.loading = false;
      state.error =
        action.error.message.split(" ")[
          action.error.message.split(" ").length - 1
        ];
      state.message = action.error.message;
    });

    builder.addCase(actions.editProfile.pending, (state) => {
      state.loading = true;
    });

    builder.addCase(actions.editProfile.fulfilled, (state, { payload }) => {
      state.loading = false;
      console.log(payload);
    });

    builder.addCase(actions.editProfile.rejected, (state, action) => {
      state.loading = false;
      state.error =
        action.error.message.split(" ")[
          action.error.message.split(" ").length - 1
        ];
      state.message = action.error.message;
    });

    builder.addCase(actions.forgotPassword.pending, (state) => {
      state.loading = true;
    });

    builder.addCase(actions.forgotPassword.fulfilled, (state, action) => {
      state.loading = false;
      state.tempUser = action.payload;
      // localStorage.setItem("tempUser", JSON.stringify(action.payload))
      // state.message = "reset"
      // state.error = "200"
    });
    builder.addCase(actions.forgotPassword.rejected, (state, action) => {
      state.loading = false;
      state.error =
        action.error.message.split(" ")[
          action.error.message.split(" ").length - 1
        ];
      state.message = action.error.message;
    });
    builder.addCase(actions.verifyOtp.pending, (state) => {
      state.loading = true;
    });
    builder.addCase(actions.verifyOtp.fulfilled, (state, action) => {
      state.loading = false;
      state.tempUser = action.payload.data;
      localStorage.setItem("tempUser", JSON.stringify(action.payload.data));
      state.message = "OTP verified successfully";
      state.error = "200";
    });
    builder.addCase(actions.verifyOtp.rejected, (state, action) => {
      state.loading = false;
      const errorMessage = action.error.message || "";
      const errorParts = errorMessage.split(" ");
      state.error = errorParts[errorParts.length - 1];
      state.message = errorMessage;
    });

    builder.addCase(actions.resetPassword.pending, (state) => {
      state.loading = true;
    });

    builder.addCase(actions.resetPassword.fulfilled, (state, action) => {
      state.loading = false;
      state.tempUser = action.payload;
      localStorage.removeItem("tempUser");
      state.message = "reset success";
      state.error = "200";
    });
    builder.addCase(actions.resetPassword.rejected, (state, action) => {
      state.loading = false;

      state.error =
        action.error.message.split(" ")[
          action.error.message.split(" ").length - 1
        ];
      state.message = action.error.message;
    });
    builder.addCase(actions.changeUserPassword.pending, (state) => {
      state.loading = true;
    });

    builder.addCase(actions.changeUserPassword.fulfilled, (state, action) => {
      state.loading = false;
      state.tempUser = action.payload;
      localStorage.removeItem("tempUser");
      state.message = "reset success";
      state.error = "200";
    });

    builder.addCase(actions.changeUserPassword.rejected, (state, action) => {
      state.loading = false;
      const errorMessage = action.error.message || "";
      const errorParts = errorMessage.split(" ");
      state.error = errorParts[errorParts.length - 1];
      state.message = errorMessage;
    });

    builder.addCase(actions.caretaker.pending, (state, action) => {
      state.loading = true;
      state.error = "";
      state.message = "";
    });

    builder.addCase(actions.caretaker.fulfilled, (state, action) => {
      state.pending = false;
      state.error = "";
      console.log(action.payload);
      state.message = "";
    });
    builder.addCase(actions.caretaker.rejected, (state, action) => {
      state.loading = false;
      state.error =
        action.error.message.split(" ")[
          action.error.message.split(" ").length - 1
        ];
      state.message = action.error.message;
    });

    builder.addCase(actions.tenant.pending, (state, action) => {
      state.loading = true;
      state.error = "";
      state.message = "";
    });

    builder.addCase(actions.tenant.fulfilled, (state, action) => {
      state.pending = false;
      state.error = "";
      console.log(action.payload);
      state.message = "";
    });
    builder.addCase(actions.tenant.rejected, (state, action) => {
      state.loading = false;
      state.error =
        action.error.message.split(" ")[
          action.error.message.split(" ").length - 1
        ];
      state.message = action.error.message;
    });

    builder.addCase(actions.fetchTenants.pending, (state) => {
      state.loading = true;
    });

    builder.addCase(actions.fetchTenants.fulfilled, (state, { payload }) => {
      state.loading = false;
      state.tenants = payload;
    });

    builder.addCase(actions.fetchTenants.rejected, (state, action) => {
      state.loading = false;
      state.error =
        action.error.message.split(" ")[
          action.error.message.split(" ").length - 1
        ];
      state.message = action.error.message;
    });

    builder.addCase(actions.updateTenant.pending, (state) => {
      state.loading = true;
    });

    builder.addCase(actions.updateTenant.fulfilled, (state, { payload }) => {
      state.loading = false;
      // console.log(payload)
    });

    builder.addCase(actions.updateTenant.rejected, (state, action) => {
      state.loading = false;
      state.error =
        action.error.message.split(" ")[
          action.error.message.split(" ").length - 1
        ];
      state.message = action.error.message;
    });
    builder.addCase(actions.relocateTenant.pending, (state, action) => {
      state.loading = true;
    });
    builder.addCase(actions.relocateTenant.fulfilled, (state, { payload }) => {
      state.loading = false;
      // console.log(payload)
    });
    builder.addCase(actions.relocateTenant.rejected, (state, action) => {
      state.loading = false;
      state.error =
        action.error.message.split(" ")[
          action.error.message.split(" ").length - 1
        ];
      state.message = action.error.message;
    });

    builder.addCase(actions.deleteTenant.pending, (state) => {
      state.loading = true;
    });

    builder.addCase(actions.deleteTenant.fulfilled, (state, { payload }) => {
      state.loading = false;
      console.log(payload);
    });

    builder.addCase(actions.deleteTenant.rejected, (state, action) => {
      state.loading = false;
      state.error =
        action.error.message.split(" ")[
          action.error.message.split(" ").length - 1
        ];
      state.message = action.error.message;
    });

    builder.addCase(actions.addProperty.pending, (state) => {
      state.loading = true;
    });

    builder.addCase(actions.addProperty.fulfilled, (state, action) => {
      state.loading = false;
      state.message = "property added successfully";
      state.error = "";
    });
    builder.addCase(actions.addProperty.rejected, (state, action) => {
      state.loading = false;
      state.error =
        action.error.message.split(" ")[
          action.error.message.split(" ").length - 1
        ];
      state.message = action.error.message;
    });
    builder.addCase(actions.editProperty.pending, (state) => {
      state.loading = true;
    });

    builder.addCase(actions.editProperty.fulfilled, (state, action) => {
      state.loading = false;
      state.message = "property edited successfully";
      state.error = "";
    });
    builder.addCase(actions.editProperty.rejected, (state, action) => {
      state.loading = false;
      state.error =
        action.error.message.split(" ")[
          action.error.message.split(" ").length - 1
        ];
      state.message = action.error.message;
    });

    builder.addCase(actions.getProperty.pending, (state) => {
      state.loading = true;
    });

    builder.addCase(actions.getProperty.fulfilled, (state, action) => {
      state.loading = false;
      state.property = action.payload;
      state.message = "property fetched successfully";
      state.error = "";
    });
    builder.addCase(actions.getProperty.rejected, (state, action) => {
      state.loading = false;
      state.error =
        action.error.message.split(" ")[
          action.error.message.split(" ").length - 1
        ];
      state.message = action.error.message;
    });

    builder.addCase(actions.updateProperty.pending, (state) => {
      state.loading = true;
    });

    builder.addCase(actions.updateProperty.fulfilled, (state, action) => {
      state.loading = false;
      console.log(action.payload);
    });

    builder.addCase(actions.updateProperty.rejected, (state, action) => {
      state.loading = false;
      state.error =
        action.error.message.split(" ")[
          action.error.message.split(" ").length - 1
        ];
      state.message = action.error.message;
    });

    builder.addCase(actions.deleteProperty.pending, (state, action) => {
      state.loading = true;
      state.message = "pending";
      state.error = "";
    });
    builder.addCase(actions.deleteProperty.fulfilled, (state, action) => {
      state.loading = false;
      console.log(action.payload);
      state.message = "property deleted successfuly";
      state.error = "";
    });
    builder.addCase(actions.deleteProperty.rejected, (state, action) => {
      state.loading = false;
      state.error =
        action.error.message.split(" ")[
          action.error.message.split(" ").length - 1
        ];
      state.message = action.error.message;
    });

    builder.addCase(actions.getAllProperties.pending, (state) => {
      state.loading = true;
    });

    builder.addCase(actions.getAllProperties.fulfilled, (state, action) => {
      state.loading = false;
      state.properties = action.payload.data;
      state.message = "fetched all properties";
      state.error = "";
    });
    builder.addCase(actions.getAllProperties.rejected, (state, action) => {
      state.loading = false;
      state.error =
        action.error.message.split(" ")[
          action.error.message.split(" ").length - 1
        ];
      state.message = action.error.message;
    });
    builder.addCase(actions.addHouse.pending, (state, action) => {
      state.loading = true;
      state.message = "pending";
      state.error = "";
    });
    builder.addCase(actions.addHouse.fulfilled, (state, action) => {
      state.loading = false;
      console.log(action.payload);
      state.message = "houses added successfuly";
      state.error = "";
    });
    builder.addCase(actions.addHouse.rejected, (state, action) => {
      state.loading = false;
      state.error =
        action.error.message.split(" ")[
          action.error.message.split(" ").length - 1
        ];
      state.message = action.error.message;
    });

    builder.addCase(actions.deleteHouse.pending, (state, action) => {
      state.loading = true;
      state.message = "pending";
      state.error = "";
    });
    builder.addCase(actions.deleteHouse.fulfilled, (state, action) => {
      state.loading = false;
      console.log(action.payload);
      state.message = "house deleted successfuly";
      state.error = "";
    });
    builder.addCase(actions.deleteHouse.rejected, (state, action) => {
      state.loading = false;
      state.error =
        action.error.message.split(" ")[
          action.error.message.split(" ").length - 1
        ];
      state.message = action.error.message;
    });

    builder.addCase(actions.updateHouse.pending, (state, action) => {
      state.loading = true;
      state.message = "pending";
      state.error = "";
    });
    builder.addCase(actions.updateHouse.fulfilled, (state, action) => {
      state.loading = false;
      console.log(action.payload);
      state.message = "houses deleted successfuly";
      state.error = "";
    });
    builder.addCase(actions.updateHouse.rejected, (state, action) => {
      state.loading = false;
      state.error =
        action.error.message.split(" ")[
          action.error.message.split(" ").length - 1
        ];
      state.message = action.error.message;
    });
    builder.addCase(actions.getAllHouses.pending, (state, action) => {
      state.loading = true;
      state.message = "pending";
      state.error = "";
    });
    builder.addCase(actions.getAllHouses.fulfilled, (state, action) => {
      state.loading = false;
      state.houses = action.payload.data;
      state.message = "houses fetched successfuly";
      state.error = "";
    });
    builder.addCase(actions.getAllHouses.rejected, (state, action) => {
      state.loading = false;
      state.error =
        action.error.message.split(" ")[
          action.error.message.split(" ").length - 1
        ];
      state.message = action.error.message;
    });

    builder.addCase(actions.sendAlerts.pending, (state, action) => {
      state.loading = true;
      state.message = "pending";
      state.error = "";
    });
    builder.addCase(actions.sendAlerts.fulfilled, (state, action) => {
      state.loading = false;
      console.log(action.payload);
      state.message = "alerts send successfuly";
      state.error = "";
    });
    builder.addCase(actions.sendAlerts.rejected, (state, action) => {
      state.loading = false;
      state.error =
        action.error.message.split(" ")[
          action.error.message.split(" ").length - 1
        ];
      state.message = action.error.message;
    });

    builder.addCase(actions.createInvoice.pending, (state, action) => {
      state.loading = true;
      state.message = "pending";
      state.error = "";
    });
    builder.addCase(actions.createInvoice.fulfilled, (state, action) => {
      state.loading = false;
      console.log(action.payload);
      state.message = "water invoice created successfuly";
      state.error = "";
    });
    builder.addCase(actions.createInvoice.rejected, (state, action) => {
      state.loading = false;
      state.error =
        action.error.message.split(" ")[
          action.error.message.split(" ").length - 1
        ];
      state.message = action.error.message;
    });

    builder.addCase(actions.listInvoices.pending, (state, action) => {
      state.loading = true;
      state.message = "pending";
      state.error = "";
    });
    builder.addCase(actions.listInvoices.fulfilled, (state, action) => {
      state.loading = false;
      state.invoices = action.payload;
      state.message = "rent invoice created successfuly";
      state.error = "";
    });
    builder.addCase(actions.listInvoices.rejected, (state, action) => {
      state.loading = false;
      state.error =
        action.error.message.split(" ")[
          action.error.message.split(" ").length - 1
        ];
      state.message = action.error.message;
    });

    builder.addCase(actions.listWaterInvoices.pending, (state) => {
      state.loading = true;
      state.message = "pending";
      state.error = "";
    });
    builder.addCase(actions.listWaterInvoices.fulfilled, (state, action) => {
      state.loading = false;
      state.waterinvoices = action.payload?.data;
      state.message = "fetched water invoices successfuly";
      state.error = "";
    });
    builder.addCase(actions.listWaterInvoices.rejected, (state, action) => {
      state.loading = false;
      state.error =
        action.error.message.split(" ")[
          action.error.message.split(" ").length - 1
        ];
      state.message = action.error.message;
    });
    builder.addCase(actions.listRentInvoices.pending, (state) => {
      state.loading = true;
      state.message = "pending";
      state.error = "";
    });
    builder.addCase(actions.listRentInvoices.fulfilled, (state, action) => {
      state.loading = false;
      state.rentInvoices = action.payload?.data;
      state.message = "fetched water invoices successfuly";
      state.error = "";
    });
    builder.addCase(actions.listRentInvoices.rejected, (state, action) => {
      state.loading = false;
      state.error =
        action.error.message.split(" ")[
          action.error.message.split(" ").length - 1
        ];
      state.message = action.error.message;
    });

    builder.addCase(actions.createRentInvoice.pending, (state, action) => {
      state.loading = true;
      state.message = "pending";
      state.error = "";
    });
    builder.addCase(actions.createRentInvoice.fulfilled, (state, action) => {
      state.loading = false;

      state.message = "rent invoice created successfuly";
      state.error = "";
    });
    builder.addCase(actions.createRentInvoice.rejected, (state, action) => {
      state.loading = false;
      state.error =
        action.error.message.split(" ")[
          action.error.message.split(" ").length - 1
        ];
      state.message = action.error.message;
    });

    builder.addCase(actions.getAllInvoicesForLandlord.pending, (state) => {
      state.loading = true;
      state.message = "pending";
      state.error = "";
    });
    builder.addCase(
      actions.getAllInvoicesForLandlord.fulfilled,
      (state, action) => {
        state.loading = false;
        state.allLandlordInvoices = action.payload?.data?.invoices;
        state.message = "fetched landlord invoices successfuly";
        state.error = "";
      }
    );
    builder.addCase(
      actions.getAllInvoicesForLandlord.rejected,
      (state, action) => {
        state.loading = false;
        state.error =
          action.error.message.split(" ")[
            action.error.message.split(" ").length - 1
          ];
        state.message = action.error.message;
      }
    );

    builder.addCase(actions.handleLogout.pending, (state, action) => {
      state.loading = true;
      state.message = "pending";
      state.error = "";
    });
    builder.addCase(actions.handleLogout.fulfilled, (state, action) => {
      state.loading = false;
      state.invoices = action.payload;
      state.message = "logged out successfuly";
      state.error = "";
    });
    builder.addCase(actions.handleLogout.rejected, (state, action) => {
      state.loading = false;
      state.error =
        action.error.message.split(" ")[
          action.error.message.split(" ").length - 1
        ];
      state.message = action.error.message;
    });

    builder.addCase(actions.fetchPaymentStatistics.pending, (state) => {
      state.loading = true;
    });

    builder.addCase(
      actions.fetchPaymentStatistics.fulfilled,
      (state, action) => {
        state.loading = false;
        state.statistics = action.payload;
      }
    );

    builder.addCase(
      actions.fetchPaymentStatistics.rejected,
      (state, action) => {
        state.loading = false;
        state.error =
          action.error.message.split(" ")[
            action.error.message.split(" ").length - 1
          ];
        state.message = action.error.message;
      }
    );

    builder.addCase(actions.fetchPendingPayments.pending, (state) => {
      state.loading = true;
    });

    builder.addCase(actions.fetchPendingPayments.fulfilled, (state, action) => {
      state.loading = false;
      state.pendingpayments = action.payload;
    });

    builder.addCase(actions.fetchPendingPayments.rejected, (state, action) => {
      state.loading = false;
      state.error =
        action.error.message.split(" ")[
          action.error.message.split(" ").length - 1
        ];
      state.message = action.error.message;
    });

    builder.addCase(actions.fetchPayments.pending, (state) => {
      state.loading = true;
    });

    builder.addCase(actions.fetchPayments.fulfilled, (state, action) => {
      state.loading = false;
      state.payments = action.payload.data;
    });

    builder.addCase(actions.fetchPayments.rejected, (state, action) => {
      state.loading = false;
      state.error =
        action.error.message.split(" ")[
          action.error.message.split(" ").length - 1
        ];
      state.message = action.error.message;
    });

    builder.addCase(actions.housesReports.pending, (state) => {
      state.loading = true;
    });

    builder.addCase(actions.housesReports.fulfilled, (state, action) => {
      state.loading = false;
      state.housesreport = action.payload;
    });

    builder.addCase(actions.housesReports.rejected, (state, action) => {
      state.loading = false;
      state.error =
        action.error.message.split(" ")[
          action.error.message.split(" ").length - 1
        ];
      state.message = action.error.message;
    });

    builder.addCase(actions.createManualPayment.pending, (state) => {
      state.loading = true;
    });

    builder.addCase(actions.createManualPayment.fulfilled, (state, action) => {
      state.loading = false;
      state.message = "payment successful";
      state.error = "";
    });
    builder.addCase(actions.createManualPayment.rejected, (state, action) => {
      state.loading = false;
      state.error =
        action.error.message.split(" ")[
          action.error.message.split(" ").length - 1
        ];
      state.message = action.error.message;
    });

    builder.addCase(actions.tenantsData.pending, (state) => {
      state.loading = true;
    });

    builder.addCase(actions.tenantsData.fulfilled, (state, action) => {
      state.loading = false;
      state.tenantsdata = action.payload;
    });

    builder.addCase(actions.tenantsData.rejected, (state, action) => {
      state.loading = false;
      state.error =
        action.error.message.split(" ")[
          action.error.message.split(" ").length - 1
        ];
      state.message = action.error.message;
    });

    builder.addCase(actions.sendMesssageTenant.pending, (state) => {
      state.loading = true;
    });

    builder.addCase(actions.sendMesssageTenant.fulfilled, (state, action) => {
      state.loading = false;
      state.message = "message sent successfully";
      state.error = "";
    });
    builder.addCase(actions.sendMesssageTenant.rejected, (state, action) => {
      state.loading = false;
      state.error =
        action.error.message.split(" ")[
          action.error.message.split(" ").length - 1
        ];
      state.message = action.error.message;
    });

    builder.addCase(actions.listTenantInvoices.pending, (state) => {
      state.loading = true;
    });

    builder.addCase(actions.listTenantInvoices.fulfilled, (state, action) => {
      state.loading = false;
      state.tenantsinvoices = action.payload;
    });

    builder.addCase(actions.listTenantInvoices.rejected, (state, action) => {
      state.loading = false;
      state.error =
        action.error.message.split(" ")[
          action.error.message.split(" ").length - 1
        ];
      state.message = action.error.message;
    });

    builder.addCase(actions.fetchTenantPayments.pending, (state) => {
      state.loading = true;
    });

    builder.addCase(actions.fetchTenantPayments.fulfilled, (state, action) => {
      state.loading = false;
      state.tenantpayments = action.payload;
    });

    builder.addCase(actions.fetchTenantPayments.rejected, (state, action) => {
      state.loading = false;
      state.error =
        action.error.message.split(" ")[
          action.error.message.split(" ").length - 1
        ];
      state.message = action.error.message;
    });

    builder.addCase(actions.listInvoicesPaid.pending, (state) => {
      state.loading = true;
    });

    builder.addCase(actions.listInvoicesPaid.fulfilled, (state, action) => {
      state.loading = false;
      state.paidinvoices = action.payload;
    });

    builder.addCase(actions.listInvoicesPaid.rejected, (state, action) => {
      state.loading = false;
      state.error =
        action.error.message.split(" ")[
          action.error.message.split(" ").length - 1
        ];
      state.message = action.error.message;
    });

    builder.addCase(actions.listAllPropertiesInvoices.pending, (state) => {
      state.loading = true;
    });

    builder.addCase(
      actions.listAllPropertiesInvoices.fulfilled,
      (state, action) => {
        state.loading = false;
        state.paidinvoices = action.payload.paidInvoices;
        state.unpaidinvoices = action.payload.unpaidInvoices;
      }
    );

    builder.addCase(
      actions.listAllPropertiesInvoices.rejected,
      (state, action) => {
        state.loading = false;
        state.error =
          action.error.message.split(" ")[
            action.error.message.split(" ").length - 1
          ];
        state.message = action.error.message;
      }
    );

    builder.addCase(actions.listInvoicesUnpaid.pending, (state) => {
      state.loading = true;
    });

    builder.addCase(actions.listInvoicesUnpaid.fulfilled, (state, action) => {
      state.loading = false;
      state.unpaidinvoices = action.payload?.data?.invoices;
      console.log("unpaid invoices set");
    });

    builder.addCase(actions.listInvoicesUnpaid.rejected, (state, action) => {
      state.loading = false;
      state.error =
        action.error.message.split(" ")[
          action.error.message.split(" ").length - 1
        ];
      state.message = action.error.message;
    });

    builder.addCase(actions.createExpense.pending, (state, action) => {
      state.loading = true;
      state.message = "pending";
      state.error = "";
    });
    builder.addCase(actions.createExpense.fulfilled, (state, action) => {
      state.loading = false;
      console.log(action.payload);
      state.message = "houses added successfuly";
      state.error = "";
    });
    builder.addCase(actions.createExpense.rejected, (state, action) => {
      state.loading = false;
      state.error =
        action.error.message.split(" ")[
          action.error.message.split(" ").length - 1
        ];
      state.message = action.error.message;
    });

    builder.addCase(actions.getAllExpenses.pending, (state, action) => {
      state.loading = true;
      state.message = "pending";
      state.error = "";
    });
    builder.addCase(actions.getAllExpenses.fulfilled, (state, action) => {
      state.loading = false;
      state.expenses = action.payload.data.expenses;
      state.message = "houses fetched successfuly";
      state.error = "";
    });
    builder.addCase(actions.getAllExpenses.rejected, (state, action) => {
      state.loading = false;
      state.error =
        action.error.message.split(" ")[
          action.error.message.split(" ").length - 1
        ];
      state.message = action.error.message;
    });

    // Draft invoice editing
    builder.addCase(actions.saveDraftInvoiceEdits.pending, (state) => {
      state.loading = true;
      state.message = "pending";
      state.error = "";
    });
    builder.addCase(actions.saveDraftInvoiceEdits.fulfilled, (state, action) => {
      state.loading = false;
      // Update the rentInvoices with the returned edited invoices
      if (action.payload?.data?.invoices && state.rentInvoices?.invoices) {
        const updatedInvoices = action.payload.data.invoices;
        state.rentInvoices = {
          ...state.rentInvoices,
          invoices: state.rentInvoices.invoices.map((inv) => {
            const updated = updatedInvoices.find((u) => u._id === inv._id);
            return updated || inv;
          }),
        };
      }
      state.message = "draft invoices updated successfully";
      state.error = "";
    });
    builder.addCase(actions.saveDraftInvoiceEdits.rejected, (state, action) => {
      state.loading = false;
      state.error = action.payload?.message || action.error.message;
      state.message = action.error.message;
    });


  },
});

export const {
  clearTenants,
  clearProperty,
  clearHouses,
  clearProperties,
  clearWaterInvoices,
  clearRentInvoices,
  clearHouseReports,
  clearPayments,
  clearInvoicesPaid,
  clearUnpaidInvoices,
  clearProfile,
  setRememberMe,
  clearRememberMe,
} = landlordSlice.actions;

export default landlordSlice.reducer;
